import { FormControl, FormGroup } from '@angular/forms';

interface ValidationResult {
  [key: string]: boolean;
}

export class CustomValidators {
  constructor() {}

  public static matchOtherField = (otherControlName: string) => {
    return (control: FormControl) => {
      if (!control.parent || !control.parent.controls[otherControlName]) {
        return null;
      }

      const otherControl = control.parent.controls[otherControlName] as FormControl;

      const invalid = control.value !== otherControl.value;

      if (invalid) {
        return { matchOtherField: true };
      }

      return null;
    };
  }

  public static checkFirstCharacterValidator(control: FormControl): ValidationResult {
    const valid = /^\d/.test(control.value);
    if (valid) {
      return { checkFirstCharacterValidator: true };
    }
    return null;
  }

  public static notGreaterThan = (otherFieldKey: string) => {
    return (control: FormControl) => {
      if ((<FormGroup>control.root).controls !== undefined && (<FormGroup>control.root).controls[otherFieldKey] !== undefined) {
        const invalid = parseFloat(control.value) > parseFloat((<FormGroup>control.root).controls[otherFieldKey].value);

        if (invalid) {
          return { notGreaterThan: true };
        }
      }

      return null;
    };
  }

  public static notLessThan = (otherFieldKey: string) => {
    return (control: FormControl) => {
      if ((<FormGroup>control.root).controls !== undefined && (<FormGroup>control.root).controls[otherFieldKey]) {
        const invalid = parseFloat(control.value) < parseFloat((<FormGroup>control.root).controls[otherFieldKey].value);

        if (invalid) {
          return { notLessThan: true };
        }
      }

      return null;
    };
  }

  public static zipCode = (zipLength: string) => {
    return (control: FormControl) => {
      if ((<FormGroup>control.root).controls !== undefined && control.value !== undefined) {
        const invalid = control.value.match(/^\d+$/) && control.value.length !== Number(zipLength);

        if (invalid) {
          return { zipCode: true };
        }
      }

      return null;
    };
  }

  public static validOldPassword = (oldPassword: string) => {
    return (control: FormControl) => {
      const valid = control.value !== oldPassword;

      if (valid) {
        return { validOldPassword: true };
      }

      return null;
    };
  }

  public static validNumber = (input: string) => {
    return (control: FormControl) => {
      console.log(input);
      return null;
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/validator/custom-validators.ts